var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeSmOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0851 2.16342C22.0851 1.30979 21.3929 0.616211 20.5379 0.616211H6.18621C5.33258 0.616211 4.639 1.30838 4.639 2.16342V7.56277C2.7787 9.07207 1.36206 10.3244 1.36206 10.6389V22.165C1.36206 23.2696 2.25749 24.165 3.36206 24.165H23.3621C24.4666 24.165 25.3621 23.2696 25.3621 22.165V10.6389C25.3621 10.3244 23.9454 9.07066 22.0851 7.56136V2.16342Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.639 7.56277V2.16342C4.639 1.30838 5.33258 0.616211 6.18621 0.616211H20.5379C21.3929 0.616211 22.0851 1.30979 22.0851 2.16342V7.56136M4.639 7.56277C2.7787 9.07207 1.36206 10.3244 1.36206 10.6389V22.165C1.36206 23.2696 2.25749 24.165 3.36206 24.165H23.3621C24.4666 24.165 25.3621 23.2696 25.3621 22.165V10.6389C25.3621 10.3244 23.9454 9.07066 22.0851 7.56136M4.639 7.56277V13.1602M22.0851 7.56136V13.1602",
    stroke: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36206 23.5266L10.0107 17.0832M16.7134 17.0832L25.3621 23.5266",
    stroke: "#262626",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36206 10.6389L10.0107 17.0833H16.7141L25.3581 10.6415",
    stroke: "#262626",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9266 4.48281C9.21273 4.51315 8.18893 6.02986 8.20979 7.25841C8.25529 9.91646 11.2025 12.3299 13.3619 13.8618C15.4663 12.2541 18.5595 9.73446 18.514 7.0783C18.4931 5.84975 17.4144 4.36905 15.7024 4.39938C14.7449 4.41645 13.9629 5.19378 13.3619 5.92938C12.7363 5.21463 11.884 4.46765 10.9266 4.48281Z",
    fill: "#F7CFDA",
    stroke: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSmOpen);
export default __webpack_public_path__ + "static/media/envelope-sm-open.98ffea0737628313b73b101a7616ddb5.svg";
export { ForwardRef as ReactComponent };